import { render, staticRenderFns } from "./BatchHandle.vue?vue&type=template&id=04d294db&scoped=true&"
import script from "./BatchHandle.vue?vue&type=script&lang=js&"
export * from "./BatchHandle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04d294db",
  null
  
)

export default component.exports